export const OWNER_ROLES = {
  NOMENCLATURE_EDITOR: 'NOMENCLATURE_EDITOR',
  ADMIN: 'ADMIN',
  SUPERMANAGER: 'SUPERMANAGER',
  MANAGER: 'MANAGER',
  SALESMAN: 'SALESMAN',
  STOCK_MANAGER: 'STOCK_MANAGER',
}

export const hiddenRoles = ['USER', 'SUPERUSER', 'user', 'superuser']

export const CLIENT_ROLES = {
  SUPERUSER: 'SUPERUSER',
  USER: 'USER',
  PRODUCT_SUPPLIER_USER: 'PRODUCT_SUPPLIER_USER',
}

export const PRODUCT_SUPPLIER_ROLES = [
  'PRODUCT_SUPPLIER_USER',
  'product_supplier_user',
]

export const ROLES_IN_RUSSIAN: { [x: string]: string } = {
  ADMIN: 'Админ',
  SUPERMANAGER: 'Суперменеджер',
  MANAGER: 'Менеджер',
  SALESMAN: 'Продажник',
  STOCK_MANAGER: 'Менеджер загрузки остатков',
  NOMENCLATURE_EDITOR: 'Редактор номенклатуры',
  CATALOG_APPROVER: 'Утверждающий каталога',
  PRODUCT_SUPPLIER_USER: 'Пользователь поставщика',
  SUPERUSER: 'Суперюзер',
  USER: 'Юзер',
  INTEGRATION: 'Интеграция (УТ)',
}

export const OWNER_ROLE_OPTIONS = [
  { value: 'ADMIN', label: 'Администратор' },
  { value: 'SUPERMANAGER', label: 'Суперменеджер' },
  { value: 'MANAGER', label: 'Менеджер' },
  { value: 'SALESMAN', label: 'Продажник' },
  { value: 'STOCK_MANAGER', label: 'Менеджер загрузки остатков' },
  { value: 'NOMENCLATURE_EDITOR', label: 'Редактор номенклатуры' },
]

export const ROLE_GROUPS = {
  SUPPLIER_STAFF: [
    'ADMIN',
    'SUPERMANAGER',
    'MANAGER',
    'SALESMAN',
    'NOMENCLATURE_EDITOR',
    'CATALOG_APPROVER',
    'STOCK_MANAGER',
  ],
  SENIOR_MANAGERS: ['ADMIN', 'SUPERMANAGER'],
  ADMINS: ['ADMIN'],
  CATALOG_EDITORS: [
    'ADMIN',
    'SUPERMANAGER',
    'NOMENCLATURE_EDITOR',
    'CATALOG_APPROVER',
  ],
  CATALOG_APPROVERS: ['ADMIN', 'CATALOG_APPROVER'],
  STORE_MANAGERS: ['ADMIN', 'SUPERMANAGER', 'STOCK_MANAGER'],
  INTEGRATION: ['INTEGRATION', 'ADMIN', 'SUPERMANAGER'],
  PURCHASE_VIEWERS: ['ADMIN', 'SUPERMANAGER', 'STOCK_MANAGER', 'INTEGRATION'],
} as const

export type RoleGroup = keyof typeof ROLE_GROUPS
